/**
 * 消息类型枚举
 */
export const MessageTypeEnum = {
  // 系统消息
  SYSTEM: {
    code: '0',
    label: '系统消息',
    key: 'system'
  },
  // 业务消息
  BUSINESS: {
    code: '1',
    label: '业务消息',
    key: 'business'
  },
  // 活动消息
  ACTIVITY: {
    code: '2',
    label: '活动消息',
    key: 'activity'
  }
}

/**
 * 根据消息类型 code 获取枚举对象
 * @param {string} code - 消息类型 code
 * @returns {Object} 枚举对象
 */
export function getMessageTypeByCode(code) {
  return Object.values(MessageTypeEnum).find(item => item.code === code) || null
}

/**
 * 根据消息类型 key 获取枚举对象
 * @param {string} key - 消息类型 key
 * @returns {Object} 枚举对象
 */
export function getMessageTypeByKey(key) {
  return Object.values(MessageTypeEnum).find(item => item.key === key) || null
}

/**
 * 根据消息类型 code 获取标签
 * @param {string} code - 消息类型 code
 * @returns {string} 消息类型标签
 */
export function getMessageTypeLabel(code) {
  const typeEnum = getMessageTypeByCode(code)
  return typeEnum ? typeEnum.label : '未知类型'
}

/**
 * 根据消息类型 key 获取标签
 * @param {string} key - 消息类型 key
 * @returns {string} 消息类型标签
 */
export function getMessageTypeLabelByKey(key) {
  const typeEnum = getMessageTypeByKey(key)
  return typeEnum ? typeEnum.label : '未知类型'
}

